import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { TransactionsApi, type TransactionResponse } from '@shared/api';

const removeReceiptEffect = createEffect((request: string) => TransactionsApi.removeReceipt(request));
const clearEvent = createEvent();

const $dataStore = createStore<TransactionResponse | null>(null)
  .on(removeReceiptEffect.done, (current, result) => result.result.data ?? current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(removeReceiptEffect.pending, (_, data) => data)
  .on(removeReceiptEffect.fail, () => false)
  .on(removeReceiptEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(removeReceiptEffect, () => null)
  // .on(removeReceiptEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(removeReceiptEffect.fail, () => 'Something went wrong while deleting Recipient. Please try again.')
  .on(removeReceiptEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $deleteReceiptStore = {
  events: {
    removeReceipt: removeReceiptEffect,
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
